import React, { Component } from "react";
import { Row, Col, Container } from "reactstrap";
import Slider from "react-slick";

import VerticalListDropdown from "corp-site/employer/verticals/components/VerticalListDropdown"

import { ThemeContext } from "../../context/ThemeContext";


import WorkWithLogo1 from "assets/img/verticals/logos/logo_amazon.png";
import WorkWithLogo2 from "assets/img/verticals/logos/logo_chipotle.png";
import WorkWithLogo3 from "assets/img/verticals/logos/logo_coca_cola.png";
import WorkWithLogo4 from "assets/img/verticals/logos/logo_fedex.png";
import WorkWithLogo5 from "assets/img/verticals/logos/logo_lyft.png";
import WorkWithLogo6 from "assets/img/verticals/logos/logo_boeing.png";
import WorkWithLogo7 from "assets/img/verticals/logos/logo_davita.png";
import WorkWithLogo8 from "assets/img/verticals/logos/logo_cintas.png";
import WorkWithLogo9 from "assets/img/verticals/logos/logo_brinks.png";


const logos = [
    { "title": "Upward Work With Amazon", "image": WorkWithLogo1 },
    { "title": "Upward Work With Chipotle", "image": WorkWithLogo2 },
    { "title": "Upward Work With Coca Cola", "image": WorkWithLogo3 },
    { "title": "Upward Work With Fedex", "image": WorkWithLogo4 },
    { "title": "Upward Work With lyft", "image": WorkWithLogo5 },
    { "title": "Upward Work With Boeing", "image": WorkWithLogo6 },
    { "title": "Upward Work With Davita", "image": WorkWithLogo7 },
    { "title": "Upward Work With Cintas", "image": WorkWithLogo8 },
    { "title": "Upward Work With Brinks", "image": WorkWithLogo9 },
];

class WorkWithCompanies extends Component{

    render(){
        var settings = {
            className: "slider variable-width",
            dots: false,
            infinite: true,
            autoplaySpeed: 1,
            speed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            autoplay: true,
            accessibility: false,
            easing: "ease",
            useCSS: true
        };
        return(
            <section className={"upward_work_with vertical_logo_display upward_work_with_"+ this.context }>
                <Container>
                    <div className="text-center">
                        <h3>We work with<br/>the best companies</h3>
                        <div className="clearfix vertical_logo_image_wrapper clearfix">
                            <div className="vertical_image_slider image_infinite_slider">
                                <Slider {...settings}>
                                    {logos && logos.length > 0 && logos.map((item, index) => (
                                        <div key={index}><img key={index} src={item.image} alt={item.title} /></div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                        <Row className="d-flex justify-content-center" >
                            <Col xs="8" sm="6" md="5" lg="3">
                                <VerticalListDropdown inverted className="btn-lg btn-block btn-rounded btn-light bg-white"><b>Clients by industry</b></VerticalListDropdown>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>
        )
    }

}

WorkWithCompanies.contextType = ThemeContext;

export default WorkWithCompanies;